import { Location } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import type { InnogyComponentRendering } from '@core/jss-models';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { DefaultComponentModule } from '@innogy/core/modules/components';
import type { ScText } from '@legacy/common-ui-models';

interface PageBackButtonRendering extends InnogyComponentRendering {
  componentName: string;
  fields: { backLabel: ScText };
}

@Component({
  selector: 'wl-page-back-button',
  templateUrl: './page-back-button.component.html',
  styleUrl: './page-back-button.component.scss',
  standalone: true,
  imports: [FontAwesomeModule, DefaultComponentModule],
})
export class PageBackButtonComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input({ required: true }) public rendering!: PageBackButtonRendering;

  private readonly _location = inject(Location);

  protected goToPreviousPage() {
    this._location.back();
  }

  protected get buttonLabel() {
    return this.rendering?.fields?.backLabel?.value ?? 'Terug';
  }
}
